import React from "react";
import { Booking } from "./WeekCalendar";

interface AgendaProps {
  bookings: Booking[];
  onEdit: (booking: Booking) => void;
  onCloseRental: (booking: Booking) => void;
}

const Agenda: React.FC<AgendaProps> = ({ bookings, onEdit, onCloseRental }) => {
  const expiredBookings = bookings.filter(
    (b) => b.end < new Date() && !b.fakturert
  );

  if (expiredBookings.length === 0) {
    return <div className="p-4 text-gray-600">Ingen utløpte leier å vise.</div>;
  }

  return (
    <div className="p-4">
      <h3 className="text-lg font-bold mb-4 text-red-700">
        Utløpte leier ({expiredBookings.length})
      </h3>

      {expiredBookings.map((b, i) => (
        <React.Fragment key={i}>
          <div className="p-3 rounded mb-2 border border-red-300 bg-red-50 text-sm">
            <div className="font-bold text-red-800">{b.title}</div>
            <div className="text-gray-600">
              {b.start.toLocaleDateString("nb-NO")} -{" "}
              {b.end.toLocaleDateString("nb-NO")}
            </div>
            <div className="flex gap-2 mt-2">
              <button
                onClick={() => onEdit(b)}
                className="px-3 py-1 text-xs rounded bg-blue-600 hover:bg-blue-700 text-white"
              >
                Rediger
              </button>
              <button
                onClick={() => onCloseRental(b)}
                className="px-3 py-1 text-xs rounded bg-green-600 hover:bg-green-700 text-white"
              >
                Avslutt
              </button>
            </div>
          </div>

          {i !== expiredBookings.length - 1 && (
            <hr className="border-t border-gray-300 my-3" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Agenda;
